import { marked } from "marked";
import type { Image } from "types/backend/models/cms/image.entity";
import { browser, dev } from "$app/environment";
import type { RequestEvent } from "@sveltejs/kit";
import type { INewProductUI } from "../routes/[[locale=lang]]/(public)/[slug=subcategory]/[fixture]/proxy+page.server";
// import { customTranslation } from "./translation";
// import { EncryptLib } from "./encrypt";
// import { UserAgentParser } from "./utils/user-agents";
// import { mangle } from "marked-mangle";
// import { gfmHeadingId } from "marked-gfm-heading-id";
// marked.use(mangle());
// marked.use(gfmHeadingId());
export enum SellerPreference {
  NO_PREFERENCE = "No Preference",
  ALL_TOGETHER = "All together",
  AVOID_LEAVING_ONE_TICKET = "Avoid leaving one ticket",
  IN_PAIRS = "In Pairs",
}
// Used by slugify
const charmap = new Map([
  ["#", "#"],
  [" ", " "],
  ["¡", "!"],
  ["¢", "c"],
  ["£", "lb"],
  ["¥", "yen"],
  ["¦", "|"],
  ["§", "SS"],
  ["¨", '"'],
  ["©", "(c)"],
  ["ª", "a"],
  ["«", "<<"],
  ["¬", "not"],
  ["­", "-"],
  ["®", "(R)"],
  ["°", "^0"],
  ["±", "+/-"],
  ["²", "^2"],
  ["³", "^3"],
  ["´", "'"],
  ["µ", "u"],
  ["¶", "P"],
  ["·", "."],
  ["¸", ","],
  ["¹", "^1"],
  ["º", "o"],
  ["»", ">>"],
  ["¼", " 1/4 "],
  ["½", " 1/2 "],
  ["¾", " 3/4 "],
  ["¿", "?"],
  ["À", "`A"],
  ["Á", "'A"],
  ["Â", "^A"],
  ["Ã", "~A"],
  ["Ä", '"A'],
  ["Å", "A"],
  ["Æ", "AE"],
  ["Ç", "C"],
  ["È", "`E"],
  ["É", "'E"],
  ["Ê", "^E"],
  ["Ë", '"E'],
  ["Ì", "`I"],
  ["Í", "'I"],
  ["Î", "^I"],
  ["Ï", '"I'],
  ["Ð", "D"],
  ["Ñ", "~N"],
  ["Ò", "`O"],
  ["Ó", "'O"],
  ["Ô", "^O"],
  ["Õ", "~O"],
  ["Ö", '"O'],
  ["×", "x"],
  ["Ø", "O"],
  ["Ù", "`U"],
  ["Ú", "'U"],
  ["Û", "^U"],
  ["Ü", '"U'],
  ["Ý", "'Y"],
  ["Þ", "Th"],
  ["ß", "ss"],
  ["à", "`a"],
  ["á", "'a"],
  ["â", "^a"],
  ["ã", "~a"],
  ["ä", '"a'],
  ["å", "a"],
  ["æ", "ae"],
  ["ç", "c"],
  ["è", "`e"],
  ["é", "'e"],
  ["ê", "^e"],
  ["ë", '"e'],
  ["ì", "`i"],
  ["í", "'i"],
  ["î", "^i"],
  ["ï", '"i'],
  ["ð", "d"],
  ["ñ", "~n"],
  ["ò", "`o"],
  ["ó", "'o"],
  ["ô", "^o"],
  ["õ", "~o"],
  ["ö", '"o'],
  ["÷", ","],
  ["ø", "o"],
  ["ù", "`u"],
  ["ú", "'u"],
  ["û", "^u"],
  ["ü", '"u'],
  ["ý", "'y"],
  ["þ", "th"],
  ["ÿ", '"y'],
  ["Ā", "A"],
  ["ā", "a"],
  ["Ă", "A"],
  ["ă", "a"],
  ["Ą", "A"],
  ["ą", "a"],
  ["Ć", "'C"],
  ["ć", "'c"],
  ["Ĉ", "^C"],
  ["ĉ", "^c"],
  ["Ċ", "C"],
  ["ċ", "c"],
  ["Č", "C"],
  ["č", "c"],
  ["Ď", "D"],
  ["ď", "d"],
  ["Đ", "D"],
  ["đ", "d"],
  ["Ē", "E"],
  ["ē", "e"],
  ["Ĕ", "E"],
  ["ĕ", "e"],
  ["Ė", "E"],
  ["ė", "e"],
  ["Ę", "E"],
  ["ę", "e"],
  ["Ě", "E"],
  ["ě", "e"],
  ["Ĝ", "^G"],
  ["ĝ", "^g"],
  ["Ğ", "G"],
  ["ğ", "g"],
  ["Ġ", "G"],
  ["ġ", "g"],
  ["Ģ", "G"],
  ["ģ", "g"],
  ["Ĥ", "^H"],
  ["ĥ", "^h"],
  ["Ħ", "H"],
  ["ħ", "h"],
  ["Ĩ", "~I"],
  ["ĩ", "~i"],
  ["Ī", "I"],
  ["ī", "i"],
  ["Ĭ", "I"],
  ["ĭ", "i"],
  ["Į", "I"],
  ["į", "i"],
  ["İ", "I"],
  ["ı", "i"],
  ["Ĳ", "IJ"],
  ["ĳ", "ij"],
  ["Ĵ", "^J"],
  ["ĵ", "^j"],
  ["Ķ", "K"],
  ["ķ", "k"],
  ["Ĺ", "L"],
  ["ĺ", "l"],
  ["Ļ", "L"],
  ["ļ", "l"],
  ["Ľ", "L"],
  ["ľ", "l"],
  ["Ŀ", "L"],
  ["ŀ", "l"],
  ["Ł", "L"],
  ["ł", "l"],
  ["Ń", "'N"],
  ["ń", "'n"],
  ["Ņ", "N"],
  ["ņ", "n"],
  ["Ň", "N"],
  ["ň", "n"],
  ["ŉ", "'n"],
  ["Ō", "O"],
  ["ō", "o"],
  ["Ŏ", "O"],
  ["ŏ", "o"],
  ["Ő", '"O'],
  ["ő", '"o'],
  ["Œ", "OE"],
  ["œ", "oe"],
  ["Ŕ", "'R"],
  ["ŕ", "'r"],
  ["Ŗ", "R"],
  ["ŗ", "r"],
  ["Ř", "R"],
  ["ř", "r"],
  ["Ś", "'S"],
  ["ś", "'s"],
  ["Ŝ", "^S"],
  ["ŝ", "^s"],
  ["Ş", "S"],
  ["ş", "s"],
  ["Š", "S"],
  ["š", "s"],
  ["Ţ", "T"],
  ["ţ", "t"],
  ["Ť", "T"],
  ["ť", "t"],
  ["Ŧ", "T"],
  ["ŧ", "t"],
  ["Ũ", "~U"],
  ["ũ", "~u"],
  ["Ū", "U"],
  ["ū", "u"],
  ["Ŭ", "U"],
  ["ŭ", "u"],
  ["Ů", "U"],
  ["ů", "u"],
  ["Ű", '"U'],
  ["ű", '"u'],
  ["Ų", "U"],
  ["ų", "u"],
  ["Ŵ", "^W"],
  ["ŵ", "^w"],
  ["Ŷ", "^Y"],
  ["ŷ", "^y"],
  ["Ÿ", '"Y'],
  ["Ź", "'Z"],
  ["ź", "'z"],
  ["Ż", "Z"],
  ["ż", "z"],
  ["Ž", "Z"],
  ["ž", "z"],
  ["ſ", "s]"],
]);

class Utils {
  public md2html(str?: string) {
    if (str) {
      return marked(str) as string;
    }
    return "";
  }

  // get current domain
  public getHost() {
    if (!browser) {
      // @TODO: - use dynamic production variable
      return dev ? "http://127.0.0.1:5173" : "http://127.0.0.1:5000";
    }

    let host = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port && window.location.port !== "80" && window.location.port !== "443") {
      host += ":" + window.location.port;
    }
    return host.trim();
  }

  // public encrypt = new EncryptLib();
  public getIp(input: RequestEvent) {
    const { request } = input;
    const ipAddress = input?.getClientAddress() || ""; // this will always be 127.0.0.1 because development
    const ipIngress = request.headers.get("x-Ingress-ip") || "";
    const ipReal = request.headers.get("x-real-ip") || "";
    const ipForwardedFor = request.headers.get("x-forwarded-for") || "";
    const ipForwardedProto = request.headers.get("x-forwarded-proto") || "";

    if (ipIngress && this.testIp(ipIngress)) {
      return ipIngress;
    } else if (ipReal && this.testIp(ipReal)) {
      return ipReal;
    } else if (ipForwardedFor && this.testIp(ipForwardedFor)) {
      return ipForwardedFor;
    } else if (ipForwardedProto && this.testIp(ipForwardedProto)) {
      return ipForwardedProto;
    } else if (ipAddress && this.testIp(ipAddress)) {
      return ipAddress;
    }

    return "127.0.0.1"; // last resort;
  }

  private testIp(ipaddress: string) {
    if (
      /^(25[0-5]|2[0-4]\d|[01]?\d\dd?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)$/.test(
        ipaddress
      )
    ) {
      if (ipaddress === "127.0.0.1") {
        return false;
      }
      return true;
    }
    // alert("You have entered an invalid IP address!");
    return false;
  }

  /**
   * Used to convert strings to be url friendly strings
   * @param  {string} s original string
   * @return {string}   url friendly string
   */
  public slugify(s: string, prefix = "/", separator = "-"): string {
    if (!s) {
      return "";
    }
    if (s.trim() === "#") {
      return "#";
    }

    const ascii: string[] = [];

    for (let i = 0, ch, cp; i < s.length; i++) {
      cp = s.charCodeAt(i);
      if (cp < 0x180) {
        ch = String.fromCharCode(cp);
        ascii.push(charmap.get(ch) || ch);
      }
    }
    s = ascii.join("");
    s = s
      .trim()
      .replace(/[^\w\s-/#]/g, "")
      .replace(/\/+$/, "")
      .toLowerCase();
    return (
      prefix +
      s
        .replace(/[-\s]+/g, separator)
        .split("/")
        .filter(n => n)
        .join("/")
    );
  }

  public nt(x: string | number, locale: string, currencyType = "GBP") {
    const nr = +x;
    return new Intl.NumberFormat(locale, { style: "currency", currency: currencyType }).format(nr);
  }

  public objSpread(...args: IJsonObj[]) {
    return args.reduce((prv, nxt) => ({ ...prv, ...nxt }));
  }

  public getSeats(seatsArr: number[]) {
    const bookedSeats = seatsArr;
    let yourSeats: string[] = [];
    bookedSeats.map((v, i) =>
      i + 1 < bookedSeats.length ? (yourSeats = [...yourSeats, ` ${v} `]) : (yourSeats = [...yourSeats, ` ${v} `])
    );
    return yourSeats;
  }

  private daySuffix(day: number) {
    if (day >= 10 && day < 20) {
      return "th";
    }
    const single = day % 10;
    if (single == 1) {
      return "st";
    }
    if (single === 2) {
      return "nd";
    }
    if (single == 3) {
      return "rd";
    }
    return "th";
  }

  // We use this to display the exact datetime from the database to the UI
  // i.e. if the game is at 20:30 +2:00,  it should show 20:30 (GMT+2) However if customer is in +8 the time turns into 04:00
  // this function reverses it so we can use Intl.DateTimeFormat
  public dateTimeZoneAdjustment(dt: Date | string) {
    if (typeof dt === "string") {
      dt = new Date(dt);
    }

    // current userTimezone
    const localOffset = new Date().getTimezoneOffset(); // Minutes
    const localDate = new Date(dt.getTime() + localOffset * 60 * 1000);

    return localDate;
  }

  public getTZTime(dt: Date | string, tbc?: { date: boolean; time: boolean }) {
    if (tbc?.date && tbc?.time) {
      return "TBC";
    }

    if (typeof dt === "string") {
      dt = new Date(dt);
    }
    return dt.toISOString().substring(11, 16);
  }

  public dateFormat(
    dt: Date | string,
    locale = "en-GB",
    options: Record<string, string | boolean> = { year: "numeric", month: "long", day: "numeric" }
  ): string {
    // example for option -> options: Record<string, string|boolean> = { year: "numeric", month: "long", day: "numeric" }
    /*
    options:{
      dateStyle: "full", "long", "medium", "short"
      timeStyle: "full", "long", "medium", "short"
      dayPeriod: "narrow", "short", "long"
      hour12: boolean,
      weekday:"long" (e.g., Thursday)
          "short" (e.g., Thu)
          "narrow" (e.g., T).
      year: "numeric" (e.g., 2012) "2-digit" (e.g., 12)
      month:  "numeric" (e.g., 3) "2-digit" (e.g., 03),
          "long" (e.g., March),
          "short" (e.g., Mar),
          "narrow" (e.g., M
      day: "numeric" (e.g., 1) "2-digit" (e.g., 01)
      hour: "numeric" (e.g., 1) "2-digit" (e.g., 01)
      minute:"numeric" (e.g., 1) "2-digit" (e.g., 01)
      second: "numeric" (e.g., 1) "2-digit" (e.g., 01)
    }
     */
    const date = typeof dt === "string" ? new Date(dt) : dt || new Date();
    return date.toLocaleDateString(locale, options);
  }

  public getDateAndTime(
    dateTime: string | Date,
    locale: string,
    type?: DateFormat,
    tbc?: { date: boolean; time: boolean }
  ) {
    // const { t } = customTranslation("common");

    if (tbc?.date && tbc?.time) {
      return "TBC";
    }

    const date = new Date(dateTime);
    if (type === DateFormat.isodt) {
      return date.toISOString().substring(0, 16) + "+00:00"; // GMT +0
    }

    if (type === DateFormat.iso) {
      return date.toISOString().substring(0, 10);
    }

    // yy - 2023
    const yy = date.getFullYear();
    // dd - 26
    const dd = `${date.getDate()}`.padStart(2, "0");
    // mm - june
    const mm = this.dateFormat(date, locale, { month: "long" });
    if (type === DateFormat.ddmmyy) {
      if (tbc?.date) {
        return "TBC";
      }
      return `${dd} ${mm} ${yy}`;
    }

    // hhmm - 16:25
    const hhmm = this.dateFormat(date, locale, { hour: "2-digit", minute: "2-digit", hour12: false })
      .substring(10)
      .trim()
      .replaceAll(/[ ,]/gi, "");
    if (type === DateFormat.hhmm) {
      if (tbc?.time) {
        return "TBC";
      }
      return `${hhmm}`;
    }
    if (type === DateFormat.mmdd) {
      if (tbc?.date) {
        return "TBC";
      }
      return `${mm} ${dd}`;
    }

    // wd - Sat
    const wd = this.dateFormat(date, locale, { weekday: "short" });
    if (type === DateFormat.wdddmmyyyy) {
      if (tbc?.date) {
        return "TBC";
      }
      return `${wd} ${this.withOrdinal(+dd)} ${tbc?.time ? " TBC" : `${mm} ${yy}`}`;
    }

    if (type === DateFormat.weekhh) {
      return (tbc?.date ? "TBC" : `${wd}`) + (tbc?.time ? " TBC" : ` ${hhmm}`);
    }

    const daySuffix = this.daySuffix(+dd);
    if (type === DateFormat.ddmmhhmm) {
      return (tbc?.date ? "TBC" : `${dd}${daySuffix} ${mm}`) + (tbc?.time ? " TBC" : ` ${hhmm}`);
    }

    // wdlong Saturday
    const wdlong = this.dateFormat(date, locale, { weekday: "long" });
    if (type === DateFormat.week) {
      // Saturday
      if (tbc?.date) {
        return "TBC";
      }
      return `${wdlong}`;
    }
    if (type === DateFormat.ddmm) {
      // 22 june
      if (tbc?.date) {
        return "TBC";
      }
      return `${dd} ${mm}`;
    }

    // mms - 6
    const mms = this.dateFormat(date, locale, { month: "numeric" }).padStart(2, "0");
    if (type === DateFormat.ddmmyyDigits) {
      if (tbc?.date) {
        return "TBC";
      }
      return `${dd}-${mms}-${yy}`;
    }
    if (type === DateFormat.weekDaymmddyy) {
      if (tbc?.date) {
        return "TBC";
      }
      // Tuesday, April 23rd, 2023
      return `${wdlong}, ${mm} ${dd}${this.daySuffix(+dd)}, ${yy}`;
    }

    // mmShort - Apr
    const mmShort = this.dateFormat(date, locale, { month: "short" });
    if (type === DateFormat.daynrmonyear) {
      if (tbc?.date) {
        return "TBC";
      }
      // Tuesday April 23rd 2023
      return `${wd} ${dd} ${mmShort} ${yy}`;
    }

    if (type === DateFormat.hours) {
      if (tbc?.time) {
        return "TBC";
      }
      // 16:23
      return `${hhmm}`;
    }
    if (type === DateFormat.yymmdd) {
      if (tbc?.date) {
        return "TBC";
      }
      // 2023-06-23
      return `${yy}-${mms}-${dd}`;
    }
    if (type === DateFormat.yymmdd2) {
      if (tbc?.date) {
        return "TBC";
      }
      // 23/07/2023
      return `${dd}/${mms}/${yy}`;
    }
    if (type === DateFormat.yy) {
      if (tbc?.date) {
        return "TBC";
      }
      // 2023
      return `${yy}`;
    }
    if (type === DateFormat.ddmmyywdtime) {
      // 23 April 2023, Saturday, 13:00

      return (tbc?.date ? "TBC " : `${dd} ${mm} ${yy}, ${wdlong} `) + (tbc?.time ? "TBC" : `${hhmm}`);
    }
    if (type === DateFormat.ddmmyyshort) {
      if (tbc?.date) {
        return "TBC";
      }
      // 23 apr 2023

      return `${dd} ${mmShort} ${yy}`;
    }
    if (type === DateFormat.ddmmhhmmsh) {
      // 30 Sep, 15:30
      return ((tbc?.date ? "TBC " : `${dd} ${mmShort}, `) + (tbc?.time ? "TBC" : `${hhmm}`)).replace(/, ,/g, ", ");
    }

    if (type === DateFormat.ddmmyyhhmm) {
      // 30 Sep, 15:30
      return ((tbc?.date ? "TBC" : `${dd} ${mm} ${yy}`) + (tbc?.time ? " - TBC" : `- ${hhmm}`)).replace(/, ,/g, ", ");
    }

    if (type === DateFormat.wdlnddmmyyyy) {
      return tbc?.date ? "TBC" : `${wdlong} ${this.withOrdinal(+dd)} ${mm} ${yy}`;
    }

    if (tbc?.date && tbc?.time) {
      return "TBC";
    }
    return (tbc?.date ? "TBC " : `${dd} ${mm} ${yy} `) + (tbc?.time ? "| TBC" : `| ${hhmm}`);
  }

  // Number ordinal 1st, 2nd, 3rd etc.
  private withOrdinal(day: number) {
    if (day > 3 && day < 21) {
      return day + "th";
    }
    switch (day % 10) {
      case 1:
        return day + "st";
      case 2:
        return day + "nd";
      case 3:
        return day + "rd";
      default:
        return day + "th";
    }
  }

  public addDT(startDt: Date | string, type: string | number, value?: number): Date {
    if (typeof startDt === "string") {
      startDt = new Date(startDt);
    }

    if (typeof type === "number") {
      // adding milliseconds
      return new Date(startDt.getTime() + type);
    }

    if (value === undefined) {
      const arr = (<string>type).split(" ");
      type = arr[1];
      value = +arr[0]; // Parse Int
    }

    const dt = new Date(startDt.getTime());

    switch (type) {
      case "s":
      case "ss":
      case "sec":
      case "second":
      case "seconds":
        dt.setUTCSeconds(dt.getUTCSeconds() + value);
        return dt;
      case "m":
      case "mm":
      case "minute":
      case "min":
      case "minutes":
        dt.setUTCMinutes(dt.getUTCMinutes() + value);
        return dt;
      case "h":
      case "hh":
      case "hour":
      case "hours":
        dt.setUTCHours(dt.getUTCHours() + value);
        return dt;
      case "d":
      case "dd":
      case "day":
      case "days":
        dt.setUTCDate(dt.getUTCDate() + value);
        return dt;
      case "w":
      case "ww":
      case "week":
      case "weeks":
        dt.setUTCDate(dt.getUTCDate() + value * 7);
        return dt;
      case "M":
      case "MM":
      case "month":
      case "months":
        dt.setUTCMonth(dt.getUTCMonth() + value);
        return dt;
      case "y":
      case "yyyy":
      case "year":
      case "years":
        dt.setUTCFullYear(dt.getUTCFullYear() + value);
        return dt;
    }
    return dt;
  }

  public toggleArray(array: Record<string, any>[], item: Record<string, any>, prop: string) {
    const index = array.findIndex(obj => obj[prop] === item[prop]);

    if (index === -1) {
      // Item does not exist, so add it to the array
      array.push(item);
    } else {
      // Item exists, so remove it from the array
      array.splice(index, 1);
    }
  }

  // @TODO:-
  // https://tinycode2.medium.com/js-and-ecmascript-date-formatting-with-ordinal-indicators-a271a23a866c
  // use new Intl.PluralRules("en", { type: "ordinal" }); <- for th, rd ,en suffix
  // use new Intl.DateTimeFormat("en", { dateStyle: "full" });

  // Create different shade of hex code colour
  public shadeColourHSL(colour: string, percent: number) {
    percent /= 100;
    const f = parseInt(colour.slice(1), 16);
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    const [hue, sat, lum] = this.rgbToHsl(R, G, B);
    return this.rgbToHex(this.hslToRgb(hue, sat, Math.max(lum + percent, 0)).join(" "));
  }

  // Convert RGB string to hex Function
  private rgbToHex(x: string) {
    return (
      "#" +
      (x.match(/\d+/g) || [])
        .map(z => {
          return (+z < 16 ? "0" : "") + (+z).toString(16);
        })
        .join("")
    );
  }

  private rgbToHsl(r: number, g: number, b: number) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h = 0;
    let s = 0;
    const l = (max + min) / 2;

    if (max == min) {
      h = s = 0; // achromatic
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return [h, s, l];
  }

  private hslToRgb(h: number, s: number, l: number) {
    let r, g, b;

    if (s == 0) {
      r = g = b = l; // achromatic
    } else {
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = this.hue2rgb(p, q, h + 1 / 3);
      g = this.hue2rgb(p, q, h);
      b = this.hue2rgb(p, q, h - 1 / 3);
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  }

  private hue2rgb(p: number, q: number, t: number) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  //Convert to RGB
  public hexToRgb(hex: string) {
    // Remove the '#' character from the beginning of the hex code
    hex = hex.replace("#", "");

    // Extract the individual color components
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Return the RGB values as an object
    return {
      r: r,
      g: g,
      b: b,
    };
  }

  // Used in ticketbuy to create the spilt for the number of tickets
  public sellerPreferenceFn(sellPreference: string, qty: number) {
    let qtyArray: number[] = [];
    switch (sellPreference) {
      case SellerPreference.ALL_TOGETHER:
        qtyArray = [+qty];
        break;
      case SellerPreference.AVOID_LEAVING_ONE_TICKET:
        qtyArray = this.avoidLeaveOne(qty);
        break;
      case SellerPreference.IN_PAIRS:
        // If seller set in Pairs but qty 1 is single seat so allowed 1 at time to sell
        if (qty > 1) {
          qtyArray = this.inPairs(qty);
        } else {
          qtyArray.push(1);
          // together = false;/
        }
        break;
      // Single ticket can be sold in multiples
      case SellerPreference.NO_PREFERENCE:
      default:
        // No preference
        qtyArray = Array(qty)
          .fill(0)
          .map((_, index) => index + 1);
        break;
    }
    return qtyArray;
  }

  // Used for filter and ticket buy
  public inPairs(qty: number) {
    const arr = Array(qty)
      .fill(qty, 0)
      .map((_, index) => index + 1);
    return arr.filter((number: number) => number % 2 === 0);
  }

  public avoidLeaveOne(qty: number) {
    const arrFromQty = Array.from({ length: qty }, (_, index) => index + 1);
    // Get the index of the second-to-last element
    const indexToRemove = arrFromQty.length - 2;
    if (indexToRemove >= 0) {
      // Use splice to remove the element at the specified index
      arrFromQty.splice(indexToRemove, 1);
    }

    return arrFromQty;
  }

  public parseContactSettings(settings: Record<string, any>, view = 7, type = "icon") {
    const socialPropNames = [
      { enable: "fbEnable", img: "facebookImg", url: "facebook", label: "Facebook" },
      { enable: "liEnable", img: "linkedinImg", url: "linkedin", label: "LinkedIn" },
      { enable: "twEnable", img: "twitterImg", url: "twitter", label: "Twitter" },
      { enable: "tiktokEnable", img: "tiktokImg", url: "tiktok", label: "Ticktock" },
      { enable: "igEnable", img: "instagramImg", url: "instagram", label: "Instagram" },
    ];

    return {
      // Social Media Icons
      socialIcons: socialPropNames
        .filter(entry => settings[entry.enable] && settings[entry.img] && settings[entry.url])
        .map(entry => ({
          type,
          icon: settings[entry.img],
          label: entry.label,
          view,
          url: settings[entry.url],
        })) as { type: string; icon: Image; label: string; url: string; view: number }[],
      // Contact
      contactInfo: {
        email: settings ? settings?.ticketListingEmail : "",
        phone: settings ? settings?.contactNumber : "",
      },
    };
  }

  public capitalizeText(text: string = "", alwaysUpper: string[] = [], ignore: string[] = []) {
    if (!text) {
      return "";
    }
    const au = new Set(alwaysUpper.map(v => v.toLowerCase()));
    const ig = new Set(ignore.map(v => v.toLowerCase()));
    const compareText = text.toLowerCase().split(" ");
    return text
      .split(" ")
      .map((v, i) => {
        if (au.has(compareText[i])) {
          return v.toUpperCase();
        }
        if (ig.has(compareText[i])) {
          return v;
        }

        if (v.indexOf("-") > -1) {
          return v
            .split("-")
            .map(w => w.charAt(0).toUpperCase() + w.substring(1))
            .join("-");
        }

        return v.substring(0, 1).toUpperCase() + v.substring(1);
      })
      .join(" ");
  }

  public isSeatTogether(product: INewProductUI, qty: number) {
    let seatTogether = false;
    let inPairs = false;
    if (qty < 2) {
      return { seatTogether, inPairs };
    }
    const { customNotes, notes, restrictions, sellPreference } = product;
    const notesAndRestrictions = [...(notes || []), ...(restrictions || [])];
    if (customNotes?.en) {
      notesAndRestrictions.push(customNotes?.en);
    }
    for (const note of notesAndRestrictions) {
      if (note.toLowerCase().includes("single")) {
        return { seatTogether, inPairs };
      }
    }

    switch (sellPreference) {
      case SellerPreference.IN_PAIRS:
        inPairs = true;
        seatTogether = true;
        break;
      default:
        seatTogether = true;
        break;
    }
    return { seatTogether, inPairs };
  }
}

export enum DateFormat {
  ddmmyy = 1, // =>19 May 2024
  hhmm = 2, // =>16:00
  wdddmmyyyy = 3, // =>Sun 19th May 2024
  mmdd = 4, // =>May 19
  weekhh = 5, // =>Sun 16:00
  ddmmhhmm = 6, // =>19th May 16:00
  week = 7, // =>Sunday
  ddmm = 8, // =>19 May
  ddmmyyDigits = 9, // =>19-05-2024
  weekDaymmddyy = 10, // =>Sunday, May 19th 2024
  ddmmyywdtime = 11, // =>19 May 2024,Sunday 16:00
  yymmdd = 12, // =>2024-05-19
  yy = 13, // =>2024
  daynrmonyear = 14, // =>Sun 19t May 2024
  hours = 15, // =>16:00
  ddmmyyshort = 16, // =>19 May 2024
  ddmmhhmmsh = 17, // =>19 May,16:00
  ddmmyyhhmm = 18, // =>19 May 2024,16:00
  yymmdd2 = 19, // =>19/05/2024
  wdlnddmmyyyy = 20, // => Sunday 19th May 2024"
  iso = 21, // =>
  isodt = 22, // =>
}
// @ TODO  ask about converting md to html ? linkify text with hyperlinks
type IJsonObj = Record<string, any>;

export const utils = new Utils();

export function makeDebounce(fn: (...args: any[]) => Promise<void> | void, ms: number = 250) {
  let debounceTimer: NodeJS.Timeout;
  if (fn.constructor.name === "AsyncFunction") {
    return (...args: any[]) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => await fn(...args), ms);
    };
  }

  return (...args: any[]) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => fn(...args), ms);
  };
}
